import React, { useState, useEffect } from "react";
import Header from "./Components/Header/Header";
import GoogleRatingCard from "./Components/GoogleRatingCard/GoogleRatingCard";
import HeroSection from "./Components/Hero/HeroSection";
import TaglineScroller from "./Components/Hero/TaglineScroller";
import LeadCaptureForm from "./Components/LeadCaptureForm/LeadCaptureForm";
import "./LandingPage.css";
import KeyAdvantages from "./Components/KeyAdvantages/KeyAdvantages";
import BankingPartners from "./Components/BankingPartners/BankingPartners";
import HowItWorks from "./Components/HowItWorks/HowItWorks";
import EligibilityDocuments from "./Components/EligibilityDocuments/EligibilityDocuments";
import Testimonials from "./Components/Testimonials/Testimonials";
import FAQSection from "./Components/FAQSection/FAQSection";
import Footer from "./Components/Footer/Footer";
import ProgressHeader from "./Components/ProgressHeader";
import PanCaptureForm from "./Components/LeadCaptureForm/PanCaptureForm";
import PersonalDetailsForm from "./Components/LeadCaptureForm/PersonalDetailsForm";
import callApi from "../../utility/apiCaller";
import OfferPage from "./Components/LeadCaptureForm/OfferSection/OffersPage";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../utility/setUserClickData";

const LandingPage = () => {
  const [isFormStarted, setIsFormStarted] = useState(false); //testing
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [params] = useSearchParams();
  const [showOfferHeaderLogo, setShowOfferHeaderLogo] = useState(false);
  const leadId = params.get("lid") || "";
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const source = params.get("source") || "";
  const utmMedium = params.get("utm_medium") || "";
  const utmTerm = params.get("utm_term") || "";
  const adsName = params.get("ads_name") || "";
  console.log(
    "affId, utmTerm, utmMedium, utmSource, source,adsName",
    affId,
    utmTerm,
    utmMedium,
    utmSource,
    source,
    adsName
  );

  useEffect(() => {
    console.log("hiii");
    console.log(leadId);
    if (leadId) {
      getDefaultOffer();
    } else {
      window.location.href = `https://web.digitmoney.in/personal-loan-v5?aff_id=${affId}&utm_medium=${utmMedium}`;
    }
  }, []);

  const getDefaultOffer = async () => {
    try {
      const leadDetailsResponse = await callApi(
        "v1/preapproved_lead/list",
        "post",
        {
          filters: { _id: leadId },
        },
        "core"
      );
      console.log(
        "leadDetailsResponse",
        leadDetailsResponse?.data.preapproved_leadCount
      );
      if (leadDetailsResponse?.data?.preapproved_leadCount > 0) {
        let leadData = leadDetailsResponse.data.preapproved_leadList[0];
        setName(leadData.contact_name);
        setAmount(leadData.loan_amount);
        console.log(name);
      } else {
        window.location.href = `https://web.digitmoney.in/personal-loan-v5?aff_id=${affId}&utm_medium=${utmMedium}`;
      }
    } catch (error) {
      window.location.href = `https://web.digitmoney.in/personal-loan-v5?aff_id=${affId}&utm_medium=${utmMedium}`;
    }
  };

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.removeItem("isFormStarted");
    };

    const sessionFlag = sessionStorage.getItem("isFormStarted");
    if (sessionFlag === "true") {
      setIsFormStarted(true);
    }
    setUserClickData({
      event_name: "pageview-website-Ploan-offers-tata-capital",
      user_id: "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
  }, []);

  useEffect(() => {
    console.log("formData: ", formData);
  }, [formData]);

  console.log("isFormStarted", isFormStarted);
  console.log("currentStep", currentStep);

  useEffect(() => {
    const video = document.querySelector(".background-video1-v3");
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Autoplay failed:", error);
        });
      }
    }
  }, []);

  return (
    <div className={"landing-page-container2"} style={{}}>
      <div className={"landing-page-v3"}>
        <Header isOfferPage={showOfferHeaderLogo} currentStep={currentStep} />

        {currentStep !== 3 && <GoogleRatingCard />}
        {!isFormStarted && currentStep !== 3 && (
          <div id="hero">
            <HeroSection name={name} amount={amount} />
          </div>
        )}
      </div>

      <div>
        {/* {isFormStarted && currentStep !== 3 && (
          <ProgressHeader
            step={currentStep}
            onBack={() => {
              if (currentStep === 1) {
                setIsFormStarted(false);
                setCurrentStep(1);
                sessionStorage.removeItem("isFormStarted");
                const form = document.getElementById("personal-loan-form");
                if (form?.resetOtpState) form.resetOtpState();
              } else {
                setCurrentStep((prev) => prev - 1);
              }
            }}
          />
        )} */}

        {isFormStarted && currentStep !== 3 && (
          <HeroSection name={name} amount={amount} />
        )}

        <div id="personal-loan-form">
          {currentStep === 1 && (
            <PersonalDetailsForm
              isFormStarted={isFormStarted}
              setIsFormStarted={() => {
                sessionStorage.setItem("isFormStarted", "true");
                setIsFormStarted(true);
              }}
              setCurrentStep={setCurrentStep}
              currentStep={currentStep}
              formData={formData}
              setFormData={setFormData}
            />
          )}

          {currentStep === 3 && (
            <OfferPage
              formData={formData}
              setFormData={setFormData}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              affId={affId}
              utmSource={utmSource}
              source={source}
              utmMedium={utmMedium}
              utmTerm={utmTerm}
              setShowOfferHeaderLogo={setShowOfferHeaderLogo}
            />
          )}
        </div>

        {!isFormStarted && (
          <>
            <KeyAdvantages />
            {/* <div id="our-partners">
              <BankingPartners />
            </div> */}
            <HowItWorks />
            <EligibilityDocuments />
            {/* <Testimonials /> */}
            <div id="faqs">
              <FAQSection />
            </div>
            <Footer />
          </>
        )}
      </div>
    </div>
  );
};

export default LandingPage;
